import moment from 'moment';

import { NotificationStatus } from '@/types/user';
import { useLocalStorage, keys } from '@/hooks/useLocalStorage';
import useSubmitResultsNotification from '../components/SubmitResultNotification/useSubmitResultsNotification';
import {
  SIMPLE_NOTIFICATION_ACTION,
  CONTENT_CHANGE_APPROVED_NOTIFICATION,
} from '../constants';

const LOCAL_STORAGE_KEY = keys.resultSubmissionNotification;
const LOCAL_STORAGE_DEFAULT_VALUE = null;

const supportedNotificationActions = [
  SIMPLE_NOTIFICATION_ACTION,
  CONTENT_CHANGE_APPROVED_NOTIFICATION,
];

const useNotifications = (allNotifications) => {
  const [
    submitResultNotificationTimestamp,
    setSubmitResultNotificationTimestamp,
  ] = useLocalStorage(LOCAL_STORAGE_KEY, LOCAL_STORAGE_DEFAULT_VALUE);
  const {
    loading: submitResultsLoading,
    submitResultEvents,
  } = useSubmitResultsNotification({
    submitResultNotificationTimestamp,
  });
  // If the user has recently seen submit results, move notification to seen. reset daily.
  const hasRecentlySeenResultSubmission =
    moment.utc(submitResultNotificationTimestamp).isValid() &&
    moment.utc() < moment.utc(submitResultNotificationTimestamp).add(1, 'days');
  const notifications =
    allNotifications?.filter((n) => {
      return supportedNotificationActions.includes(n.action.__typename);
    }) ?? [];
  const unseenNotifications = notifications.filter(
    (n) => n.status === NotificationStatus.UNSEEN,
  );
  const seenNotifications = notifications.filter(
    (n) => n.status !== NotificationStatus.UNSEEN,
  );
  const newNotificationLength =
    unseenNotifications.length +
    ((!hasRecentlySeenResultSubmission && submitResultEvents?.length) || 0);
  const noNotifications =
    !unseenNotifications.length &&
    !seenNotifications.length &&
    !submitResultEvents?.length;

  return {
    unseenNotifications,
    seenNotifications,
    newNotificationLength,
    noNotifications,
    setSubmitResultNotificationTimestamp,
    submitResultsLoading,
    submitResultEvents,
    hasRecentlySeenResultSubmission,
  };
};

export default useNotifications;
